import React, {useState, useEffect, useContext} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Button from '@material-ui/core/Button'
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import ReplayIcon from '@material-ui/icons/Replay'
import AddIcon from '@material-ui/icons/Add'
import RemoveIcon from '@material-ui/icons/Delete'

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

const moveArrayElement = (array, element, offset) => {
    const index = array.indexOf(element)
    const newIndex = index + offset
    if (newIndex > -1 && newIndex < array.length) {
        const removedElement = array.splice(index, 1)[0]
        array.splice(newIndex, 0, removedElement)
    }
    return array
}

const removeArrayElement = (array, element) => {
    const index = array.indexOf(element);
    if (index > -1) {
        array.splice(index, 1);
    }
    return array
}

const MessageList = ({languageTips}) => {
    const firebaseContext = useContext(_firebaseContext)
    const appContext = useContext(_appContext)

    const [changed, setChanged] = useState(false)
    const [tips, setTips] = useState([])
    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);


    useEffect(() => {
        if (languageTips.data.tipsArray) {
            setTips(languageTips.data.tipsArray);
        }
    }, [languageTips]);

    const updateTips = (newTips) => {
        setTips(newTips)
        setChanged(true)
        forceUpdate()
    }

    const reloadFromDatabase = async () => {
        const tips = await firebaseContext.getTips(languageTips.id);
        setTips(tips);
        setChanged(false);
    }

    const sendTipsToDb = async (tips, tipsCollectionName) => {
        const isDataSent = await firebaseContext.saveTips(tips, tipsCollectionName);
        if (!isDataSent && tipsCollectionName !== 'tips') {
            appContext.snackbar.showSnackbarMsg(`Произошла ошибка при сохранении подсказки в ${tipsCollectionName}. Данные не были сохранены.`);
            return false;
        }
        /**
         *  Для tips выводим двойную ошибку, т.к далее не будет отдельной попытки обновить tips_ru, если изначальная
         *  коллекция tips не обновилась (обратная совместимость со старыми версиями)
         */
        if (!isDataSent && tipsCollectionName === 'tips') {
            appContext.snackbar.showSnackbarMsg(`Произошла ошибка при сохранении подсказки в tips и tips_ru. Данные не были сохранены.`);
            return false;
        }

        return true;
    }

    const saveTips = async () => {
        if (languageTips.id) {
            /**
             * Для обратной совместимости старых версий, при изменении подсказок с ru локалью - вносим
             * изменения и для ранее созданной, изначальной коллекции tips. Пробуем обновить старую коллекцию,
             * если не вышло - выводим уведомление и не пробуем обновлять новую (должны быть одинаковые данные).
             */
            if (languageTips.id === 'tips_ru') {
                const isTipsSent = await sendTipsToDb(tips, 'tips');
                if (!isTipsSent) {
                    setChanged(false);
                    return;
                }
            }

            await sendTipsToDb(tips, languageTips.id);
            setChanged(false);
        }
    }

    const addTip = async () => {
        tips.push({label: '', text: ''});
        updateTips(tips)
    }

    const classes = useStyles()

    return (
        <div className={classes.controlsWrapper}>
            <Button onClick={saveTips} color='primary' disabled={!changed}>
                Сохранить
            </Button>
            <Button onClick={reloadFromDatabase} color='primary' disabled={!changed}>
                <ReplayIcon/>
            </Button>
            {tips.map((tip, i) => (
                <ListItem
                    alignItems='flex-start'
                    className={classes.commentWrapper}
                    key={`tip${i}`}
                >
                    <div className={classes.itemContainer}>
                        <div>
                            <ArrowUpwardIcon onClick={() => updateTips(moveArrayElement(tips, tip, -1))}/>
                            <ArrowDownwardIcon onClick={() => updateTips(moveArrayElement(tips, tip, 1))}/>
                        </div>
                        <div>
                            <ListItemText>
                                <TextField
                                    autoFocus
                                    fullWidth
                                    label='Заголовок'
                                    required={true}
                                    type='text'
                                    value={tip.label}
                                    onChange={(event) => {
                                        const currentTips = tips.slice()
                                        currentTips[i].label = event.target.value
                                        updateTips(currentTips)
                                    }}
                                    multiline
                                />
                                <TextField
                                    fullWidth
                                    label='Текст'
                                    required={true}
                                    type='text'
                                    value={tip.text}
                                    onChange={(event) => {
                                        const currentTips = tips.slice()
                                        currentTips[i].text = event.target.value
                                        updateTips(currentTips)
                                    }}
                                    multiline
                                />
                            </ListItemText>
                        </div>
                        <div>
                            <RemoveIcon onClick={() => updateTips(removeArrayElement(tips, tip))}/>
                        </div>
                    </div>
                </ListItem>
            ))
            }
            <Button onClick={addTip} color='primary'>
                <AddIcon/>
            </Button>
        </div>
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        overflow: 'auto',
        position: 'relative',
        maxHeight: '65vh'
    },
    inline: {
        display: 'inline'
    },
    datePicker: {
        marginTop: '15px',
        marginBottom: '15px',
        marginRight: '25px'
    },
    controlsWrapper: {},
    commentWrapper: {
        cursor: 'pointer'
    },
    itemContainer: {
        display: 'flex',
        flexDirection: 'row'
    },
    commentText: {
        maxHeight: '70px',
        overflow: 'hidden',
        textAlign: 'justify',
        paddingRight: '1em',
        position: 'relative',

        '&::before': {
            content: "'...'",
            position: 'absolute',
            right: 0,
            bottom: 0
        },

        '&::after': {
            content: "''",
            position: 'absolute',
            right: 0,
            width: '1em',
            height: '1em',
            background: theme.palette.background.paper,
            marginTop: '0.2em'
        }
    },
}));

export default MessageList;
